import React, { useEffect, useState } from "react";
import { Typography, Grid, Stack, Container, Button, Box } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import User from "../assets/logo/man_1.png";
import Worker from "../assets/logo/worker_1.png";
import PageHeader from "../components/PageHeader";
import SignUpImage from "../assets/Images/SignUp.png";
import "../App.css";
import { isMobile } from "react-device-detect";
import LogoImage from "../assets/Images/Vector.png";

const ChooseFlow = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [flowType, setFlowType] = useState();
  const [userType, setUserType] = useState("");
  useEffect(() => {
    if (location.state?.flow) {
      setFlowType(location.state.flow);
    }
  }, []);
  if (isMobile) {
    return (
      <Box
        sx={{ display: "flex" }}
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Stack direction="column">
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            className="mb-5"
            justifyContent="center"
            style={{ width: "100%" }}
          >
            <img
              src={LogoImage}
              alt="logo"
              style={{ height: "33px", width: "50px" }}
            />
            <span
              className="default-color"
              style={{
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              Amannat
            </span>
          </Stack>
          <Stack>
            <Typography>Please download the Ammanat Mobile App.</Typography>
          </Stack>
        </Stack>
      </Box>
    );
  }
  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={12} md={6}>
          <Container maxWidth="sm" style={{ height: "100vh" }}>
            <PageHeader />
            <Grid container className="mb-16">
              <Typography
                variant="h4"
                className="default-font flow-title"
                style={{ marginTop: "100px" }}
                gutterBottom
                component="div"
              >
                Join as a User or Service Provider
              </Typography>
              <Typography className="grey-text" variant="body1" gutterBottom>
                Please {flowType == "login" ? "login to" : "create"} an account
                and stay updated.
              </Typography>
            </Grid>

            <div style={{ width: "100%" }}>
              {/* <div style={{ margin: "auto",width:'40%' }}> */}

              <Stack direction="row" spacing={6}>
                <Stack>
                  <Button
                    variant="outlined"
                    className="choose-flow flex-col"
                    onClick={() => setUserType("user")}
                    style={
                      userType == "user"
                        ? { border: "2px solid #0A64BC" }
                        : null
                    }
                  >
                    <img src={User} />
                    <Typography
                      style={{ fontSize: "13px", textTransform: "capitalize" }}
                    >
                      I’m a user, looking for service
                    </Typography>
                  </Button>
                </Stack>
                <Button
                  variant="outlined"
                  className="choose-flow"
                  onClick={() => setUserType("serviceProvider")}
                  style={
                    userType == "serviceProvider"
                      ? { border: "2px solid #0A64BC" }
                      : null
                  }
                >
                  <img src={Worker} />
                  <Typography
                    style={{ fontSize: "13px", textTransform: "capitalize" }}
                  >
                    I’m a service provider, looking for work
                  </Typography>
                </Button>
              </Stack>
              {flowType == "login" ? (
                <Stack spacing={2}>
                  <Stack>
                    <Button
                      variant="contained"
                      disabled={userType == "" ? true : false}
                      className={
                        userType == ""
                          ? "mt-13 w-90"
                          : "mt-13 w-90 primary-button"
                      }
                      style={{ width: "85%" }}
                      onClick={() =>
                        userType == "user"
                          ? navigate("/login")
                          : navigate("/serviceProviderLogin")
                      }
                    >
                      Sign in
                    </Button>
                  </Stack>
                  <Stack>
                    <Typography
                      className="default-font"
                      style={{
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "21px",
                        color: "rgba(119, 119, 119, 1)",
                      }}
                    >
                      Don't have an account?{" "}
                      <span
                        style={{
                          cursor: "pointer",
                          color: "rgba(10, 100, 188, 1)",
                        }}
                        className="text-decoration-none text-bold default-font"
                        onClick={() => {
                          setUserType("");
                          setFlowType("register");
                        }}
                      >
                        Register here
                      </span>
                    </Typography>
                  </Stack>
                </Stack>
              ) : (
                <Stack spacing={2}>
                  <Stack>
                    <Button
                      variant="contained"
                      disabled={userType == "" ? true : false}
                      className={
                        userType == ""
                          ? "mt-13 w-90"
                          : "mt-13 w-90 primary-button"
                      }
                      style={{ width: "85%" }}
                      onClick={() =>
                        userType == "user"
                          ? navigate("/register")
                          : navigate("/serviceProviderRegister")
                      }
                    >
                      Create an Account
                    </Button>
                  </Stack>
                  <Stack>
                    <Typography
                      className="default-font"
                      style={{
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "21px",
                        color: "rgba(119, 119, 119, 1)",
                      }}
                    >
                      Already have an account?{" "}
                      <Link to="/login">
                        <span
                          style={{
                            cursor: "pointer",
                            color: "rgba(10, 100, 188, 1)",
                          }}
                          className="text-decoration-none text-bold default-font"
                          // onClick={() => {
                          //   setUserType("");
                          //   setFlowType("login");
                          // }}
                        >
                          Login Here
                        </span>
                      </Link>
                    </Typography>
                  </Stack>
                </Stack>
              )}

              {/* </div> */}
            </div>
          </Container>
        </Grid>
        <Grid item sm={12} md={6}>
          <div>
            <img
              src={SignUpImage}
              style={{ width: "100%", height: "100vh" }}
              loading="lazy"
            />
            <Typography
              style={{
                position: "absolute",
                top: "75%",
                color: "white",
                fontWeight: "700",
                fontSize: "28px",
                lineHeight: "37px",
                padding: "20px",
              }}
            >
              What a great experience using Amaanat! I booked all of my services
              for my gap year through Amannat and never had any issues.{" "}
            </Typography>
            <Typography
              style={{
                position: "absolute",
                top: "90%",
                color: "white",
                fontWeight: "000",
                fontSize: "20px",
                lineHeight: "27px",
                padding: "20px",
              }}
            >
              Sara Loren
            </Typography>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default ChooseFlow;
